module.exports = __webpack_public_path__ + "efee9badbc4163f0483f4d0d479f9552.svg";